import Axios, { type AxiosRequestConfig } from "axios"
import userManager from "./UserManager"
import { config as appConfig } from "./config"

export const customInstance = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<{ data: T; status: number }> => {
  const source = Axios.CancelToken.source()

  const backendUrl = appConfig.backendHost

  const user = await userManager.getUser()

  const bearerToken = user?.access_token
  const idToken = user?.id_token

  // Create headers object with Authorization header and X-Id-Token if available
  const headers = {
    ...(config.headers || {}),
    ...(options?.headers || {}),
    ...(bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {}),
    ...(idToken ? { "X-Id-Token": idToken } : {}),
  }

  const promise = Axios.create({
    baseURL: backendUrl,
    timeout: 10000, // 10 second timeout
  })({
    ...config,
    ...options,
    headers,
    cancelToken: source.token,
  }).then(({ data, status }) => ({ data, status }))

  // @ts-expect-error - promise.cancel is not defined in the type definition
  promise.cancel = () => {
    source.cancel("Query was cancelled")
  }

  return promise
}

export default customInstance
